import { QueryClientProvider } from '@tanstack/react-query';
import { IntlProvider } from 'react-intl';
import { Flex, Box } from 'rebass/styled-components';
import noop from 'lodash/noop';

import { ThemeProviderV2 } from '@blueprint/ui';
import defaultTheme from '@blueprint/theme';

import { GlobalStyle } from 'components/GlobalStyle/GlobalStyle';
import GetSupportButton from 'components/GetSupportButton';
import Docker from 'components/Docker';
import { oneColumnLayout } from 'themes';
import { useAppConfig, useFetchAppConfig } from 'state/appConfig';
import { overrideTheme } from 'themes/overrideTheme';
import { useTriggerChatbot } from 'hooks/useTriggerChatbot';
import { useIsSupportPanelOpen } from 'state/isSupportPanelOpen';
import {
  useConnectAuthConversationRestoreError,
  useConnectInConversationError,
} from 'genesys/error/connect-error-event-state';
import { useLoggedInMessagingServiceReady } from 'genesys/useLoggedInMessagingServiceReady';
import { useHandleGenesysReAuthentication } from 'hooks/useHandleGenesysReAuthentication';

function App({ queryClient }) {
  useFetchAppConfig();
  useTriggerChatbot();

  const { locale } = useAppConfig();

  const isSupportPanelOpen = useIsSupportPanelOpen();

  useConnectAuthConversationRestoreError();
  useConnectInConversationError();
  useLoggedInMessagingServiceReady();
  useHandleGenesysReAuthentication();

  return (
    <>
      <GlobalStyle />

      <QueryClientProvider client={queryClient}>
        <ThemeProviderV2 theme={overrideTheme(defaultTheme)}>
          <IntlProvider onError={noop} locale={locale}>
            <Flex
              sx={{
                position: 'fixed',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10000,
                [oneColumnLayout]: isSupportPanelOpen
                  ? {
                      top: 0,
                      transform: 'none',
                    }
                  : {},
              }}
            >
              <Box marginY="auto">
                <GetSupportButton />
              </Box>
              <Docker isOpen={isSupportPanelOpen} />
            </Flex>
          </IntlProvider>
        </ThemeProviderV2>
      </QueryClientProvider>
    </>
  );
}

export default App;
